<template>
  <client-only>
    <component :is="renderTemp" />
  </client-only>
</template>
<script>
  import NEWPublicSkuTemplate from '@page_detail/components/NEWPublicSkuTemplate'
  import NEWCategorySkuTemplate from '@page_detail/components/NEWCategorySkuTemplate'
  import olbStateOfSurvival from '@page_detail/components/SpecialSkuModule/StateOfSurvival'
  import styleConfiguration from '@/mixins/detail/styleConfiguration'
  import { mapGetters } from 'vuex'
  export default {
    mixins: [styleConfiguration],
    name: 'New-Pack-Template',
    components: {
      NEWPublicSkuTemplate,
      NEWCategorySkuTemplate,
      olbStateOfSurvival,
    },
    props: {},
    data() {
      return {}
    },
    computed: {
      ...mapGetters(['isStateOfSurvival']),
      // 单独处理
      renderTemp() {
        const Temps = {
          list: 'NEWCategorySkuTemplate',
          default: 'NEWPublicSkuTemplate',
        }
        if (this.isStateOfSurvival) return olbStateOfSurvival
        return this.skuModuleType === 2 ? Temps['list'] : Temps['default']
      },
    },
  }
</script>
